import { MENA_COUNTRY_CODES } from "@template/state/modules/menaBanner/constants";
import { getHasWelcomeMessageBeenDismissed } from "../dismissalTracking/getHasWelcomeMessageBeenDismissed";
import { getIsPageCountHighEnough } from "../pageCountTracking/getIsPageCountHighEnough";

export const getShouldDisplay = ({ geoCountry, browseCountry }) => {
  if (
    MENA_COUNTRY_CODES.includes(geoCountry) ||
    geoCountry === browseCountry ||
    getHasWelcomeMessageBeenDismissed() ||
    !getIsPageCountHighEnough()
  ) {
    return false;
  }

  return true;
};
